"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialShare = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SocialShare = require("./SocialShare.styles");
var _SocialShare2 = require("./SocialShare.labels");
var _hooks = require("../../hooks");
var _A = require("../../UI/A");
var _Button = require("../../UI/Button");
var _Modal = require("../../Layout/Modal");
var _SocialShare3 = require("./SocialShare.helpers");
var _SocialShareBtn = require("./partials/SocialShareBtn");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _strings = require("../../utilities/strings");
var _Icon = require("../../UI/Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var teamsScript = {
  src: "https://teams.microsoft.com/share/launcher.js",
  checkIfAlreadyLoaded: function checkIfAlreadyLoaded() {
    return window.shareToMicrosoftTeams;
  }
};
var classRoomScript = {
  src: "https://apis.google.com/js/platform.js",
  checkIfAlreadyLoaded: function checkIfAlreadyLoaded() {
    var _window$gapi;
    return (_window$gapi = window.gapi) === null || _window$gapi === void 0 ? void 0 : _window$gapi.sharetoclassroom;
  }
};
var useScriptsList = {
  scriptsList: [classRoomScript, teamsScript]
};
var SocialShare = function SocialShare(props) {
  var _error$failedScriptDa, _error$failedScriptDa2;
  var getLabel = (0, _hooks.useLabels)({
    labels: _SocialShare2.labels
  });
  var _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'popup' : _props$layout,
    title = props.title,
    _props$headerTitle = props.headerTitle,
    headerTitle = _props$headerTitle === void 0 ? getLabel('share') : _props$headerTitle,
    messageLineText = props.messageLineText,
    _props$url = props.url,
    url = _props$url === void 0 ? '' : _props$url,
    whatsappText = props.whatsappText,
    _props$summary = props.summary,
    summary = _props$summary === void 0 ? '' : _props$summary,
    onClose = props.onClose,
    onBack = props.onBack,
    _props$shareList = props.shareList,
    shareList = _props$shareList === void 0 ? [] : _props$shareList;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var _useScripts = (0, _hooks.useScripts)(useScriptsList),
    isReady = _useScripts.isReady,
    error = _useScripts.error;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isPopupOpen = _useState2[0],
    setIsPopupOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isCopySuccess = _useState4[0],
    setIsCopySuccess = _useState4[1];
  var styles = (0, _SocialShare.useStyles)(props, isCopySuccess);
  var urlInputRef = (0, _react.useRef)(null);
  var shareMicrosoftTeamsBtnRef = (0, _react.useRef)(null);
  var googleClassroomBtnRef = (0, _react.useRef)(null);
  var timerRef = (0, _react.useRef)();
  var optionalData = (0, _SocialShare3.getOptionalDataByUrl)(url);
  var handleClose = function handleClose(event) {
    setIsPopupOpen(false);
    if (onClose) {
      onClose(event);
    }
  };
  var handleBack = function handleBack(event) {
    if (onBack) {
      onBack(event);
    }
  };
  var handleClick = function handleClick() {
    return false;
  };
  var handleCopyUrl = function handleCopyUrl() {
    if (urlInputRef !== null && urlInputRef !== void 0 && urlInputRef.current) {
      urlInputRef.current.select();
    }
    document.execCommand('copy');
    setIsCopySuccess(true);
    timerRef.current = setTimeout(function () {
      setIsCopySuccess(false);
    }, 5000);
  };
  (0, _react.useEffect)(function () {
    var timer = timerRef.current;
    return function () {
      if (timer) {
        window.clearTimeout(timer);
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (shareMicrosoftTeamsBtnRef.current && isReady) {
      var _window$shareToMicros;
      (_window$shareToMicros = window.shareToMicrosoftTeams) === null || _window$shareToMicros === void 0 ? void 0 : _window$shareToMicros.renderButtons({
        elements: [shareMicrosoftTeamsBtnRef.current]
      });
    }
  }, [shareMicrosoftTeamsBtnRef, isReady, summary, title, url]);
  (0, _react.useEffect)(function () {
    if (googleClassroomBtnRef.current && isReady) {
      var _window$gapi2, _window$gapi2$shareto;
      var maxLength = 1000;
      var pTitle = title || '';
      var pSummary = summary || '';
      pTitle = (0, _strings.clearHtmlTags)(pTitle);
      pSummary = (0, _strings.clearHtmlTags)(pSummary);
      if (pTitle.length + pSummary.length + url.length > maxLength) {
        pTitle = pTitle.substring(0, window.Math.max(100, maxLength - pSummary.length - url.length));
        pSummary = pSummary.substring(0, maxLength - pTitle.length - url.length);
      }
      var pTitleEncodeLength = window.encodeURIComponent(pTitle).length;
      var urlEncodeLength = window.encodeURIComponent(url).length;
      while (pSummary.length > 0 && pTitleEncodeLength + urlEncodeLength + window.encodeURIComponent(pSummary).length > maxLength) {
        pSummary = pSummary.substring(0, pSummary.length - 1);
      }
      (_window$gapi2 = window.gapi) === null || _window$gapi2 === void 0 ? void 0 : (_window$gapi2$shareto = _window$gapi2.sharetoclassroom) === null || _window$gapi2$shareto === void 0 ? void 0 : _window$gapi2$shareto.render(googleClassroomBtnRef.current, {
        url: url,
        body: pSummary,
        title: pTitle,
        itemtype: 'material'
      });
    }
  }, [googleClassroomBtnRef, isReady, summary, title, url]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-SocialShare'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal, {
      layout: layout,
      isOpen: isPopupOpen,
      onClose: handleClose,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
        title: headerTitle,
        subTitle: title
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Content, {
        children: [messageLineText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "cc-SocialShare__message",
          children: messageLineText
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-SocialShare__options'],
          children: [shareList.includes('link') && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-SocialShare__option'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: styles['cc-SocialShare__option__input'],
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                ref: urlInputRef,
                readOnly: true,
                value: url,
                "aria-label": getLabel('socialShare_socialBtn_link')
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: styles['cc-SocialShare__option__feedback'],
              children: getLabel('socialShare_urlCopyFeedback')
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
              id: "ccSocialShareButton",
              color: "basic",
              view: "outlined",
              size: "stretch",
              shape: "roundedRectangle",
              onClick: handleCopyUrl,
              category: "shareFlow",
              label: "copyLink",
              optionalData: optionalData,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialShareBtn.SocialShareBtn, {
                id: "link",
                icon: "Link",
                text: getLabel('socialShare_socialBtn_link'),
                isSuccess: isCopySuccess
              })
            })]
          }), shareList.includes('whatsapp') && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-SocialShare__option'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
              isBtnView: true,
              color: "basic",
              view: "outlined",
              size: "stretch",
              shape: "roundedRectangle",
              to: "https://api.whatsapp.com/send?text=".concat(whatsappText ? window.encodeURIComponent(whatsappText) + ' %0a ' : '').concat(window.encodeURIComponent(url)),
              target: "_blank",
              category: "shareFlow",
              label: "shareInWhatsApp",
              optionalData: optionalData,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialShareBtn.SocialShareBtn, {
                id: "whatsapp",
                icon: "Whatsapp",
                text: getLabel('socialShare_socialBtn_whatsapp')
              })
            })
          }), shareList.includes('googleClassroom') && (error === null || error === void 0 ? void 0 : (_error$failedScriptDa = error.failedScriptData) === null || _error$failedScriptDa === void 0 ? void 0 : _error$failedScriptDa.src) !== (classRoomScript === null || classRoomScript === void 0 ? void 0 : classRoomScript.src) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-SocialShare__option'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ref: googleClassroomBtnRef,
              className: styles['cc-SocialShare__option__mask']
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
              id: "ccSocialShareGoogleClassButton",
              color: "basic",
              view: "outlined",
              size: "stretch",
              shape: "roundedRectangle",
              customStyle: {
                background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light
              },
              pointerEvents: "none",
              category: "shareFlow",
              label: "shareClassroom",
              optionalData: optionalData,
              onClick: handleClick,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialShareBtn.SocialShareBtn, {
                id: "googleClassroom",
                text: getLabel('socialShare_socialBtn_googleClassroom'),
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                  name: "GoogleClassroom",
                  width: 24,
                  height: 24
                })
              })
            })]
          }), shareList.includes('teams') && (error === null || error === void 0 ? void 0 : (_error$failedScriptDa2 = error.failedScriptData) === null || _error$failedScriptDa2 === void 0 ? void 0 : _error$failedScriptDa2.src) !== (teamsScript === null || teamsScript === void 0 ? void 0 : teamsScript.src) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-SocialShare__option'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ref: shareMicrosoftTeamsBtnRef,
              className: styles['cc-SocialShare__option__mask'],
              "data-preview": true,
              "data-href": url,
              "data-assign-title": (title === null || title === void 0 ? void 0 : title.substring(0, 50)) || '',
              "data-assign-instr": (0, _strings.clearHtmlTags)(summary, 200)
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
              id: "ccSocialShareMicrosoftTeamsButton",
              color: "basic",
              view: "outlined",
              size: "stretch",
              shape: "roundedRectangle",
              pointerEvents: "none",
              category: "shareFlow",
              label: "shareTeams",
              optionalData: optionalData,
              onClick: handleClick,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialShareBtn.SocialShareBtn, {
                id: "teams",
                text: getLabel('socialShare_socialBtn_microsoftTeams'),
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                  name: "MicrosoftTeams",
                  width: 24,
                  height: 24
                })
              })
            })]
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer, {
        justifyContent: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            view: "outlined",
            color: "primary",
            onClick: onBack ? handleBack : handleClose,
            id: "ccSocialShareBackButton",
            children: getLabel(onBack ? 'back' : 'close')
          })
        })
      })]
    })
  });
};
exports.SocialShare = SocialShare;